<template>
  <div class="app">
    <aside class="mdc-drawer" v-show="isAsideVisible">
      <div class="mdc-drawer__header">
        <img class="logo" alt="Business Model Canvas Tool" src="/static/logo-bmc-white.png" />
        <p
          class="small"
        >Made with ❤️ by hola@albertvazquez.es</p>
        <p class="small">
          💡 Would you improve it?
          <a
            @click="onClickOnFeedback()"
            target="_blank"
            href="https://docs.google.com/forms/d/e/1FAIpQLSefqCzE18BPMSK_UUn7bEeoh2OOeDDhbxko6q5wHXDORdmWtw/viewform"
          >Leave feedback</a>
        </p>
        <p class="small underline">
          <strong>All changes are permanently saved</strong>
        </p>
      </div>
      <hr class="mdc-list-divider" />
      <div class="mdc-drawer__content">
        <nav class="mdc-list">
          <a
            @click="onClickOnUserSettings()"
            v-if="this.user && this.user.uid"
            class="mdc-list-item"
            href="#"
            aria-selected="true"
          >
            <i class="material-icons mdc-list-item__graphic" aria-hidden="true">settings</i>
            <span class="mdc-list-item__text">{{this.user.email}}</span>
          </a>
          <a
            v-if="!this.user || !this.user.uid"
            @click="onClickOnLogIn()"
            class="mdc-list-item"
            href="#"
            aria-selected="true"
          >
            <i class="material-icons mdc-list-item__graphic" aria-hidden="true">perm_identity</i>
            <span class="mdc-list-item__text">Log in</span>
          </a>
          <a
            v-if="!this.user || !this.user.uid"
            @click="onClickOnSignUp()"
            class="mdc-list-item"
            href="#"
            aria-selected="true"
          >
            <i class="material-icons mdc-list-item__graphic" aria-hidden="true">person_add</i>
            <span class="mdc-list-item__text">Sign up</span>
          </a>
          <a
            v-if="this.user && this.user.uid"
            @click="onClickOnSignOut()"
            class="mdc-list-item"
            href="#"
            aria-selected="true"
          >
            <i class="material-icons mdc-list-item__graphic" aria-hidden="true">exit_to_app</i>
            <span class="mdc-list-item__text">Sign out</span>
          </a>
          <hr class="mdc-list-divider" />
          <h6 class="mdc-list-group__subheader">Canvas</h6>

          <a @click="onClickOnAddCanvas()" class="mdc-list-item" href="#" aria-selected="true">
            <i class="material-icons mdc-list-item__graphic" aria-hidden="true">add</i>
            <span class="mdc-list-item__text">Create</span>
          </a>
          <hr class="mdc-list-divider" />
          <a
            v-for="(c, idx) in canvas"
            @click="onClickOnCanvas(idx)"
            :key="c.id"
            class="mdc-list-item"
            :class="{'mdc-list-item--activated': selectedCanvasIdx === idx}"
          >
            <i class="material-icons mdc-list-item__graphic" aria-hidden="true">view_module</i>
            <span class="mdc-list-item__text">{{c.name}}</span>
          </a>
        </nav>
      </div>
      <div class="ad">
        <p>Top 2 para emprendedores 💰</p>
        <div class="books">
          <a href="https://amzn.to/2SeH2bl" target="_blank"><img src="/static/fourhour.jpg" alt="Jornada Laboral 4 horas" /></a>
          <a href="https://amzn.to/3btdPRz" target="_blank"><img src="/static/padrerico.jpg" alt="Padre Rico, Padre Pobre" /></a>
        </div>
        <p class="notice">En calidad de Afiliado de Amazon, obtengo ingresos por las compras adscritas que cumplen los requisitos aplicables</p>
      </div>
    </aside>
    <div @click="onClickOnCanvasComponent" class="main">
      <Canvas
        @onClickOnNav="onClickOnNav"
        @onClickOnHelp="onClickOnHelp"
        v-if="selectedCanvas && selectedCanvas.id"
        @onCanvasDeleted="onCanvasDeleted()"
        @onTitleEdited="onCanvasTitleEdited"
        @onItemCreated="onItemCreated"
        @onItemDeleted="onItemDeleted"
        @onColorEdited="onCanvasColorEdited"
        :color="selectedCanvas.color"
        :name="selectedCanvas.name"
        :items="selectedCanvas.items"
        :id="selectedCanvas.id"
      ></Canvas>
      <div v-if="!selectedCanvas || !selectedCanvas.id" class="h-100 no-canvas-selected">
        <h1>No canvas selected</h1>
      </div>
    </div>
    <LoginDialog
      @onClosed="onLoginDialogClosed()"
      @onLogedIn="onLogedIn"
      :visible="isLogInDialogVisible"
    ></LoginDialog>
    <SignUpDialog
      @onClosed="onSignUpDialogClosed()"
      @onSignedUp="onSignedUp"
      :visible="isSignUpDialogVisible"
    ></SignUpDialog>
    <UserSettingsDialog
      @onClosed="onUserSettingsClosed()"
      @onAccountDeleted="onAccountDeleted()"
      :user="user"
      :visible="isUserSettingsVisible"
    ></UserSettingsDialog>
    <KeyPartnersHelpDialog
      @onClosed="onCloseHelpDialog()"
      :visible="selectedTopicHelp === 'key-partners'"
    ></KeyPartnersHelpDialog>
    <KeyActivitiesHelpDialog
      @onClosed="onCloseHelpDialog()"
      :visible="selectedTopicHelp === 'key-activities'"
    ></KeyActivitiesHelpDialog>
    <KeyResourcesHelpDialog
      @onClosed="onCloseHelpDialog()"
      :visible="selectedTopicHelp === 'key-resources'"
    ></KeyResourcesHelpDialog>
    <ValuePropositionsHelpDialog
      @onClosed="onCloseHelpDialog()"
      :visible="selectedTopicHelp === 'value-propositions'"
    ></ValuePropositionsHelpDialog>
    <CustomerRelationshipsHelpDialog
      @onClosed="onCloseHelpDialog()"
      :visible="selectedTopicHelp === 'customer-relationships'"
    ></CustomerRelationshipsHelpDialog>
    <ChannelsHelpDialog @onClosed="onCloseHelpDialog()" :visible="selectedTopicHelp === 'channels'"></ChannelsHelpDialog>
    <CustomerSegmentsHelpDialog
      @onClosed="onCloseHelpDialog()"
      :visible="selectedTopicHelp === 'customer-segments'"
    ></CustomerSegmentsHelpDialog>
    <CostStructureHelpDialog
      @onClosed="onCloseHelpDialog()"
      :visible="selectedTopicHelp === 'cost-structure'"
    ></CostStructureHelpDialog>
    <RevenueStreamsHelpDialog
      @onClosed="onCloseHelpDialog()"
      :visible="selectedTopicHelp === 'revenue-streams'"
    ></RevenueStreamsHelpDialog>
  </div>
</template>

<script>
import * as uuid from "uuid";
import Canvas from "./components/Canvas.vue";
import LoginDialog from "./components/LoginDialog.vue";
import SignUpDialog from "./components/SignUpDialog.vue";
import UserSettingsDialog from "./components/UserSettingsDialog.vue";
import KeyPartnersHelpDialog from "./components/help-dialog/KeyPartnersHelpDialog.vue";
import KeyResourcesHelpDialog from "./components/help-dialog/KeyResourcesHelpDialog.vue";
import KeyActivitiesHelpDialog from "./components/help-dialog/KeyActivitiesHelpDialog.vue";
import ValuePropositionsHelpDialog from "./components/help-dialog/ValuePropositionsHelpDialog.vue";
import CustomerRelationshipsHelpDialog from "./components/help-dialog/CustomerRelationshipsHelpDialog.vue";
import ChannelsHelpDialog from "./components/help-dialog/ChannelsHelpDialog.vue";
import CustomerSegmentsHelpDialog from "./components/help-dialog/CustomerSegmentsHelpDialog.vue";
import CostStructureHelpDialog from "./components/help-dialog/CostStructureHelpDialog.vue";
import RevenueStreamsHelpDialog from "./components/help-dialog/RevenueStreamsHelpDialog.vue";

import { AnalyticsService } from "@/services/AnalyticsService.js";

import { PersistService } from "./services/PersistService.js";
import { AuthService } from "./services/AuthService.js";

const DEFAULT_CANVAS = [
  {
    id: uuid.v4(),
    name: "My first canvas",
    items: {},
    color: "#F56991"
  }
];

export default {
  name: "app",
  created() {
    AuthService.subscribeUser(this.$firebase).subscribe(user => {
      this.user = user;
      PersistService.getModel(this.$firebase).then(model => {
        if (this.user && this.user.uid && this.canvas.length) {
          this.canvas = [...this.canvas, ...model];
        } else {
          this.canvas = model || DEFAULT_CANVAS;
        }
      });
    });
  },
  data() {
    return {
      selectedCanvasIdx: 0,
      canvas: [],
      isLogInDialogVisible: false,
      isSignUpDialogVisible: false,
      user: {},
      isUserSettingsVisible: false,
      selectedTopicHelp: null,
      isAsideVisible: false
    };
  },
  methods: {
    onClickOnNav() {
      this.isAsideVisible = !this.isAsideVisible;
    },
    onClickOnCanvasComponent() {
      if (this.canvas.length && this.selectedCanvasIdx >= 0) {
        this.isAsideVisible = false;
      }
    },
    onClickOnCanvas(idx) {
      this.selectedCanvasIdx = idx;
    },
    onClickOnAddCanvas() {
      this.canvas.push({
        id: uuid.v4(),
        name: `My canvas ${this.canvas.length + 1}`,
        items: {},
        color: "#F56991"
      });
      AnalyticsService.onCreateCanvas();
    },
    onItemDeleted(group, index) {
      this.canvas[this.selectedCanvasIdx].items[group].splice(index, 1);
      AnalyticsService.onDeleteCanvasItem();
    },
    onItemCreated(group, label) {
      if (!this.canvas[this.selectedCanvasIdx].items[group]) {
        this.$set(this.canvas[this.selectedCanvasIdx].items, group, []);
      }
      this.canvas[this.selectedCanvasIdx].items[group].push({
        id: uuid.v4(),
        label
      });
      AnalyticsService.onCreateCanvasItem();
    },
    onCanvasTitleEdited(title) {
      this.canvas[this.selectedCanvasIdx].name = title;
      AnalyticsService.onRenameCanvas();
    },
    onCanvasColorEdited(color) {
      this.canvas[this.selectedCanvasIdx].color = color;
      AnalyticsService.onChangeColorCanvas();
    },
    onCanvasDeleted() {
      this.canvas.splice(this.selectedCanvasIdx, 1);
      this.selectedCanvasIdx = 0;
      AnalyticsService.onDeleteCanvas();
    },
    persist(model) {
      PersistService.setModel(this.$firebase, model);
    },
    onClickOnLogIn() {
      if (this.isLogInDialogVisible) {
        this.isLogInDialogVisible = false;
      }
      setImmediate(() => {
        this.isLogInDialogVisible = true;
      });
    },
    onClickOnUserSettings() {
      this.isUserSettingsVisible = true;
    },
    onClickOnSignUp() {
      this.isSignUpDialogVisible = true;
    },
    onSignedUp(user) {
      this.user = {
        email: user.email,
        uid: user.uid
      };
      this.isSignUpDialogVisible = false;
      AnalyticsService.onSignedUp();
    },
    onLogedIn(user) {
      this.isLogInDialogVisible = false;
      AnalyticsService.onLogedIn();
    },
    onLoginDialogClosed() {
      this.isLoginDialogVisible = false;
    },
    onSignUpDialogClosed() {
      this.isSignUpDialogVisible = false;
    },
    onUserSettingsClosed() {
      this.isUserSettingsVisible = false;
    },
    onClickOnSignOut() {
      this.canvas = [];
      AuthService.signOut(this.$firebase);
      AnalyticsService.onLogedOut();
    },
    onAccountDeleted() {
      this.isUserSettingsVisible = false;
      this.canvas = [];
      AnalyticsService.onAccountDeleted();
    },
    onClickOnHelp(item) {
      this.selectedTopicHelp = item;
    },
    onCloseHelpDialog() {
      this.selectedTopicHelp = null;
    },
    onClickOnFeedback() {
      AnalyticsService.onClickOnFeedback();
    }
  },
  computed: {
    selectedCanvas() {
      return this.canvas[this.selectedCanvasIdx] || {};
    }
  },
  watch: {
    canvas: {
      deep: true,
      handler(model) {
        this.persist(model);
        if (!model.length) {
          this.isAsideVisible = true;
        }
      }
    }
  },
  components: {
    Canvas,
    LoginDialog,
    SignUpDialog,
    UserSettingsDialog,
    KeyPartnersHelpDialog,
    KeyResourcesHelpDialog,
    KeyActivitiesHelpDialog,
    ValuePropositionsHelpDialog,
    CustomerRelationshipsHelpDialog,
    ChannelsHelpDialog,
    CustomerSegmentsHelpDialog,
    CostStructureHelpDialog,
    RevenueStreamsHelpDialog
  }
};
</script>

<style lang="scss">
@import "./style/main.scss";
.small {
  color: #666;
  font-size: 12px;
}
.color-primary {
  color: var(--mdc-theme-primary);
}
.no-canvas-selected {
  display: flex;
  justify-content: center;
  align-items: center;
  color: #999;
  padding: 0 10px;
}

html {
  height: 100%;
}
body {
  height: 100%;
  font-family: "Roboto", sans-serif;
  background: #f6f6f6;
}
.app,
.mdc-drawer,
.main {
  height: 100%;
}

.app {
  display: flex;
  overflow: auto;
}
.mdc-drawer {
  width: 250px;
  .mdc-drawer__header {
    text-align: center;
    .logo {
      width: 80%;
    }
    p {
      margin-top: 0;
    }
  }
  .mdc-drawer__content {
    position: relative;
  }
  .ad {
    bottom: 0;
    height: 230px;
    padding: 10px;
    background: #f6f6f6;
    .books {
      display: flex;
      justify-content: space-between;
      img {
        width: 100px
      }
    }
    p {
      margin: 10px 0;
      color: #333;
    }
    p.notice {
      font-size: 10px;
      margin: 5px 0;
    }
    .subtitle {
      font-size: 14px;
      font-weight: 200;
      color: #555;
    }
    a {
    }
    p.title {
      font-size: 20px;
    }
  }
}
.main {
  flex: 1;
  max-width: 100%;
}

@media (max-width: 768px) {
  .hide-xs {
    display: none;
  }
  .mdc-drawer .ad {
    height: 210px;
    p {
      margin: 2px 0;
    }
    .subtitle {
      font-size: 10px;
    }
    p.title {
      font-size: 14px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue